
import VueRouter from 'vue-router'
import { ProviderAuth } from '@/gql'
import { mergeControls, apolloClient } from '@/js/apollo'
import { routes } from './routes'


const router = new VueRouter({
  history: true,
  routes
})


// handles any special stuff needed special for any page
router.beforeEach((to, from, next) => {
  // anybody need an app bar?
  // also want to uncondiionally stop anything playing
  // and set up the target type for the next page if relevant
  const tob = to.matched.find(record => record.meta && record.meta.targetType)
  const targetType = tob ? tob.meta.targetType : ''
  mergeControls({
    showAppBar: to.matched.some(record => record.meta && record.meta.showAppBar),
    playing: '',
    targetType
  })
  // setlast selectedType so we cn always know whats be
  if(targetType) {
    mergeControls ({
      selectedType: targetType
    })
  }

  // anybody need to be logged in first ?
  if (to.matched.some(record => record.meta.authRequred)) {
    apolloClient.query({ query: ProviderAuth }).then(result => {
      const { ProviderAuth } = result.data
      if (!ProviderAuth.providerID) {
        next({
          path: '/login',
          query: { redirect: to.fullPath }
        })
      } else {
        next()
      }
    })
  } else {
    next()
  }
})

// keep a note of where we've been - useful for going back after a login
router.afterEach((to, from) => {
  if (!from.meta || !from.meta.skipTracking) {
    mergeControls({
      routerTo: to.path,
      routerFrom: from.path
    })
  }
})

export default router
